var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-title"},[_vm._t("content",function(){return [_vm._v(_vm._s(_setup.props.content))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }